import { createReducer, on } from '@ngrx/store';
import * as thisActions from '../actions/loader.actions';
import { MyLoadable } from '@models/my-loadable';

export const loaderFeatureKey = 'loader';

export interface LoaderPartialState {
  readonly [loaderFeatureKey]: MyLoadable;
}

export const initialState: MyLoadable = {
  success: true,
  error: '',
  okMessage: '',
  loading: false
};

export const loaderReducer = createReducer(initialState,
  on(thisActions.showLoader, state => {
    return {
      ...state,
      loading: true
    };
  }),
  on(thisActions.closeLoader, state => {
    return {
      ...state,
      loading: false
    };
  })
);
